<template>
    <div class="product-highlights">
        <div v-for="item in list" :key="item.id" class="item  base-shadow" @click="goDetail(item)">
            <div class="left">
                <img :src="item.detail.img" alt="">
            </div>
            <div class="right">
                <div class="name">{{ item.detail.name }}</div>
                <div class="intro">{{ item.detail.intro }}</div>
            </div>
        </div>
    </div>
</template>
<script>
const { CMS } = window.env
import { getDataRows, sleep } from '@custouch/proxy-use'
export default {
    props: ['hId'],
    data(){
        return{
            list: []
        }
    },
    async created(){
        const { data } = await getDataRows({
            dataHierarchyId: this.hId,
            dataTemplateId: CMS.template.susArticle,
            index: 1,
            size: 99,
            orderBy: 'index',
            desc: false
        })
        this.list = data
    },
    methods: {
        async goDetail(item){
            if(item.detail.link){
                this.$root.$emit('actionview', {
                    info: {
                        remark: `点击跳转至站外链接-${item.detail.name}`,
                        to: item.detail.link
                    },
                    actionType: 'clickview'
                })
                await sleep(150)
                window.location.href = item.detail.link
            }else{
                this.$router.push({
                    name: 'productHighlightsDetail',
                    params: {
                        rId: item.id,
                        hId: this.hId
                    }
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.product-highlights{
    padding: 0 @padding-md @padding-md;
    .item{
        display: flex;
        align-items: center;
        margin-bottom: @padding-md;
        background: @white;
        padding: 0.3rem @padding-sm 0.3rem 0.3rem;
        border-radius: @border-radius-sm + @border-radius-md;
        .left{
            width: 7.15rem;
            height: 4rem;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            img{
                width: 100%;
                object-fit: contain;
                border-radius: @border-radius-md;
            }
        }
        .right{
            padding: 0.5rem 0 @padding-sm @padding-sm;
            color: @green;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name{
                line-height: @line-height-md;
                font-weight: @font-weight-bold;
            }
            .intro{
                .ellipsis(false, 2);
                font-size: @font-size-sm;
            }
        }
    }
}
</style>